/**
 * The main sidebar's two widths, as tokens.
 *
 * They describe the app shell, but they are not only the shell's business: a
 * full-bleed table has to know how much room the sidebar leaves it, and those
 * tables live in `domains/` and `ui/` — below the layer that owns the sidebar.
 * Reaching up into `layout/MainSidebar/const` for them was an upward import in
 * five files, so the numbers live here, where every layer may read them and
 * none owns them.
 *
 * `layout/MainSidebar/const` re-exports these under the same names, so the
 * sidebar's own code is unchanged and there is still one definition.
 */
export const DRAWER_WIDTH = 264;
/**
 * The rail's width, and it is arithmetic rather than taste.
 *
 * A rail icon is centred in the column INSIDE the drawer's 1px right border,
 * so its centre sits at half of (this - 1). An open row puts its icon at
 * `SIDEBAR_GUTTER` (12) + the row's own 10px padding, centred on a 16px
 * glyph — 30. Sixty-one is the width that makes those two the same number, so
 * folding the nav moves no icon: only the words go. At the design's 62 every
 * glyph stepped a pixel sideways on the way in; at 60 it landed on a half
 * pixel and every rail icon rendered soft.
 */
export const COLLAPSED_WIDTH = 61;

/**
 * The gutter the content column holds either side of the page.
 *
 * The page's inset from the nav is the top bar's 26px; `PageContainer`
 * contributes 16 of that from inside, so the column outside it contributes the
 * difference. Named here rather than in the layout because the background map
 * has to know it too — it is the one element that reaches PAST the page to the
 * column's real edges — and `shared/` may not read `layout/`.
 */
export const PAGE_CONTENT_GUTTER = 10;

/**
 * The top bar's height — and, less one pixel of rule, the nav's logo row.
 * Shared so the rule under the logo and the bar's bottom border meet as one
 * line across the toggle. `PageContainer` reads it too, to size a page to the
 * viewport that is left below the bar.
 */
export const TOP_BAR_HEIGHT = 57;
